module.exports = __webpack_public_path__ + "xkompl.png?aec6b74c0f8d68acadf3039f56ec3bd6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xkompl.png
// module id = 1020
// module chunks = 2